// extracted by mini-css-extract-plugin
export default {"group":"KPILeanSelect_group__F42PT","button":"KPILeanSelect_button__w0TLj"};